import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { GroupDashboardService } from 'app/groups/services/group-dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services';
import { UtilsWidgetService } from '../services/utils-widget.service';
import moment from 'moment';

const DEFAULT_ACTIVITY = {
  total: 0,
  averageDuration: 0,
  totalDuration: 0,
  averageProgress: 0
};

@Component({
  selector: 'lms-recent-activity-widget',
  templateUrl: './recent-activity-widget.component.html',
  styleUrls: ['./recent-activity-widget.component.scss']
})
export class RecentActivityWidgetComponent implements WidgetComponent, OnInit {
  @Input() data: any;
  @Input() keys?: object;

  public totalsStudents: any = {};
  public activeStudentsActivity: any = {};
  public inactiveStudentsActivity: any = {};
  public connectedUnits: string;
  public averageDurationUnits: string;

  public tooltipText: string;
  public secondaryTooltipText: string;
  public tertiaryTooltipText: string;
  private tooltipSubscription: Subscription = new Subscription();

  constructor(public dataService: GroupDashboardService, public translate: TranslateService) {}

  ngOnInit() {
    this.connectedUnits = this.translate.instant('groups.dashboard.units.connectedStudents');
    this.averageDurationUnits = this.translate.instant('groups.dashboard.units.hours');

    this.dataService
      .getActivity({
        groupId: this.data.group._id,
        fromEndDate: moment().endOf('day').subtract(15, 'days').toISOString()
      })
      .subscribe((activity) => {
        this.activeStudentsActivity = activity || DEFAULT_ACTIVITY;
        this.totalsStudents.active = activity && activity.total ? activity.total : 0;
      });

    this.dataService
      .getActivity({
        groupId: this.data.group._id,
        toEndDate: moment().endOf('day').subtract(15, 'days').toISOString(),
        licenseStatus: ['beforeDemo', 'afterDemo']
      })
      .subscribe((activity) => {
        this.inactiveStudentsActivity = activity || DEFAULT_ACTIVITY;
        this.totalsStudents.inactive = activity && activity.total ? activity.total : 0;
      });

    this.getTooltips();
  }

  /**
   * Get the message of the tooltips
   * @private
   */
  private getTooltips(): void {
    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(
        tooltipObject,
        this.data.action,
        this.keys['recentActivity']
      );

      this.secondaryTooltipText = UtilsWidgetService.containTooltip(
        tooltipObject,
        this.data.action,
        this.keys['connected']
      );

      this.tertiaryTooltipText = UtilsWidgetService.containTooltip(
        tooltipObject,
        this.data.action,
        this.keys['averageDuration']
      );
    });
  }
}
